<template>
    <div :class="[{ 'alternative-offer': isAlternativeOffer }, 'offer-block', { expired: isOfferExpired }]">
        <div class="row">
            <div :class="[offer.lender.logo.url ? 'col-lg-10' : '', 'col-12 order-lg-3']">
                <div class="row">
                    <div class="col-12 d-flex">
                        <EligibilityLabel
                            v-if="isLendindtree && !isOfferExpired"
                            :offer="offer"
                            :isAlternativeOffer="isAlternativeOffer"
                            :isDebtSolutionOffer="isDebtSolutionOffer"
                        />
                        <ExpiredLabel v-else-if="isOfferExpired" :offer="offer" :resubmitEnabled="resubmitEnabled" />
                        <ApprovalLabel
                            v-else
                            :offer="offer"
                            :isAlternativeOffer="isAlternativeOffer"
                            :isDebtSolutionOffer="isDebtSolutionOffer"
                        />
                    </div>
                </div>

                <div v-if="isCreditOffer">
                    <OfferLenderName :lenderName="offer?.lender?.name" />
                </div>

                <div v-if="!isAlternativeOffer && !isDebtSolutionOffer" class="row">
                    <div class="col-12 d-lg-none">
                        <TagContainer
                            :offer="offer"
                            :loanAmount="loanAmount"
                            :loanTerm="loanTerm"
                            :isOfferExpired="isOfferExpired"
                            :fastFundingFlagStatus="fastFundingFlagStatus"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <div class="row small-gutters">
                            <div
                                v-if="offer.lender.logo.url"
                                :class="[
                                    isAlternativeOffer || isDebtSolutionOffer ? 'col-12 col-md-5' : 'col-5',
                                    'd-flex d-lg-none mb-3 mb-lg-0 justify-content-center',
                                ]"
                            >
                                <OfferLenderLogo :offer="offer" :isOfferExpired="isOfferExpired" />
                            </div>

                            <div
                                :class="[
                                    isAlternativeOffer || isDebtSolutionOffer
                                        ? 'col-12 col-md-7 align-items-center'
                                        : 'col-7',
                                    'col-lg-9 order-lg-2 d-flex mb-3 mb-lg-0',
                                ]"
                            >
                                <slot></slot>
                            </div>

                            <div class="col-12 col-lg-3 order-lg-3 d-lg-flex continue-container justify-content-center">
                                <div
                                    :class="[
                                        isDebtSolutionOffer
                                            ? 'align-content-center debt-solution-cta'
                                            : 'align-content-start',
                                        'row offer-button-padding',
                                    ]"
                                >
                                    <div
                                        class="col-5 col-lg-12 order-lg-2 d-flex align-self-center offer-details pe-0"
                                        :class="{ invisible: isOfferExpired }"
                                        @click="showOfferDetails"
                                        v-if="!isDebtSolutionOffer"
                                    >
                                        <p>
                                            {{ $t('results.offerDetails') }}
                                        </p>
                                        <div v-show="!openAccordian" class="offer-details-icon">
                                            <i class="fas fa-angle-down align-self-center d-none d-lg-flex"></i>
                                        </div>
                                        <div v-show="openAccordian" class="offer-details-icon">
                                            <i class="fas fa-angle-up align-self-center d-none d-lg-flex"></i>
                                        </div>
                                    </div>

                                    <div
                                        :class="[
                                            isDebtSolutionOffer ? 'col-12 justify-content-center' : 'col-7',
                                            'col-lg-12 order-lg-1 d-flex ps-1 ps-md-3',
                                        ]"
                                        v-if="!isAgentPage"
                                    >
                                        <OfferCtaButton
                                            :offer="offer"
                                            :isOfferExpired="isOfferExpired"
                                            :isCreditCardCampaign="isCreditCardCampaign"
                                            :expired="expired"
                                            :resubmitEnabled="resubmitEnabled"
                                            :offerIndex="offerIndex"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                v-if="offer.lender.logo.url"
                :class="[isDebtSolutionOffer ? 'col-12' : 'col-6', 'col-lg-2 order-lg-2 d-none d-lg-flex']"
            >
                <OfferLenderLogo :offer="offer" :isOfferExpired="isOfferExpired" :resubmitEnabled="resubmitEnabled" />
            </div>

            <div v-if="!isDebtSolutionOffer" class="col-12 order-lg-4 mt-4 p-0">
                <div :class="[openAccordian ? 'opened' : 'closed', 'accordian-content']">
                    <div class="accordian-inner-content">
                        <AboutLender :offer="offer" />
                    </div>
                </div>

                <div class="loan-example">
                    <p :class="isDebtConsolidationLoan?.class" v-html="isDebtConsolidationLoan?.content"></p>

                    <div v-if="offer.type != 'alternative' && offer.rapr">
                        <p>{{ $t('results.repExample') }}: <span v-html="offer.rapr"></span></p>
                    </div>
                </div>

                <FullScreenModal :name="offer.id" :forceNoOverlay="true">
                    <template v-slot:topHeading>
                        <h2 class="offer-details-modal-title">
                            {{ $t('results.offerDetails') }}
                        </h2>
                    </template>

                    <AboutLender :offer="offer" />
                </FullScreenModal>
            </div>
        </div>
    </div>
</template>

<script>
const DEBT_CONSOLIDATION_LOAN_PURPOSE = 7
import { useRoute, useRouter } from 'vue-router'
import { computed } from 'vue'

import isDate from 'lodash/isDate'
import { useStore } from 'vuex'

export default {
    props: [
        'offer',
        'isAlternativeOffer',
        'expired',
        'offerIndex',
        'offerCount',
        'isAgentPage',
        'loanAmount',
        'loanTerm',
        'fastFundingFlagStatus',
        'loanPurpose',
    ],
    setup() {
        const store = useStore()
        const router = useRouter()
        const route = useRoute()

        return {
            router,
            route,
            store,
        }
    },
    data() {
        return {
            openAccordian: false,
            model: {
                component: 'aboutLender',
            },
            windowWidth: window.screen.width,
            ctaPayload: {},
            ctaDisabled: false,
        }
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.windowWidth = window.screen.width
        })
    },
    methods: {
        showOfferDetails: function () {
            this.trackEvent('event', {
                eventCategory: 'button',
                eventAction: 'click',
                eventLabel: 'offer-details',
            })

            this.trackEvent('results_element_click', {
                elementType: 'click',
                elementName: 'offer-details',
            })
            this.openAccordian = !this.openAccordian
        },
        getOfferType: function () {
            return this.type
        },
    },
    computed: {
        territory: function () {
            return window.TERRITORY
        },
        isCreditOffer: function () {
            return (
                this.offer.type === 'line_of_credit' ||
                this.offer.type === 'credit_card' ||
                this.offer.type === 'credit card only'
            )
        },
        type: function () {
            let type = this.offer.group

            if (this.offer.type === 'car_finance') {
                type = 'car'
            } else if (this.offer.secured) {
                type = 'secured'
            }

            return type
        },
        isOfferExpired: function () {
            if (this.expired) {
                return true
            }

            if (this.offer.offer_expires && isDate(new Date(this.offer.offer_expires))) {
                let date = new Date(this.offer.offer_expires)
                let now = new Date()

                return now >= date
            }
        },
        resubmitEnabled: function () {
            return !!this.store.state.global.data.resubmit_show_form
        },
        isCreditCardCampaign: function () {
            return window.CAMPAIGN_TYPE === 'Credit Card'
        },
        isDebtSolutionOffer: function () {
            return this.offer.type === 'debt_solution' && this.territory === 'gbr'
        },
        isLendindtree: function () {
            return process.env.IS_LENDINDTREE
        },
        isDebtConsolidationLoan: function () {
            if (
                this.loanPurpose !== DEBT_CONSOLIDATION_LOAN_PURPOSE &&
                this.type === 'secured' &&
                this.territory === 'gbr'
            ) {
                return {
                    class: 'default',
                    content: this.$t('results.default.securedMessaging'),
                }
            }

            if (
                this.loanPurpose === DEBT_CONSOLIDATION_LOAN_PURPOSE &&
                this.type === 'secured' &&
                this.territory === 'gbr'
            ) {
                return {
                    class: 'debtConsolidation',
                    content: this.$t('results.debtConsolidation.securedMessaging'),
                }
            }
        },
    },
    provide() {
        return {
            offerGroup: this.type,
            offer: computed(() => this.offer),
        }
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/mixins/rem';
@import '~scss/settings/responsive';
@import '~scss/mixins/gutter-size';

.offer-block {
    background-color: var(--white);
    border: 1px solid #e6e6e6;
    border-radius: 4px;
    box-shadow: 0px 3px 16px rgba(0, 0, 0, 0.08);
    margin-bottom: 16px;
    padding: 18px 16px;

    &.expired {
        background-color: #f1f1f1;
    }

    &.alternative-offer {
        padding-bottom: 0px;
    }

    .loan-example {
        border-top: 1px solid #e5e5e5;
        color: black;
        padding-top: 16px;

        p {
            font-size: rem(11px);
            margin: 0;
            padding: 0 15px;

            @media screen and (min-width: $bp-large) {
                font-size: rem(13px);
                padding: 0 25px;
            }
        }
        .default,
        .debtConsolidation {
            font-size: rem(10px);
            font-weight: 600;
            @media screen and (min-width: $bp-large) {
                font-size: rem(13px);
            }
        }
    }

    .small-gutters {
        @include resize-gutter(10px);

        @media screen and (min-width: $bp-medium) {
            @include resize-gutter(30px);
        }
    }

    .offer-details {
        justify-content: center;

        p,
        .offer-details-icon {
            color: var(--primary);
            cursor: pointer;
            font-size: rem(13px);
            font-weight: 400;
            margin-bottom: 0;

            @media screen and (min-width: $bp-medium) {
                font-size: rem(14px);
            }
        }

        .offer-details-icon {
            margin-top: 3px;
            margin-left: 5px;
        }
    }

    .offer-button-padding {
        @media screen and (min-width: $bp-large) {
            margin-right: 10px;
        }
    }

    .debt-solution-cta {
        @media screen and (min-width: $bp-large) {
            width: 100%;
        }
    }

    .accordian-content {
        background-color: #f4f5f6;
        overflow: hidden;
        transition: max-height 1s ease;

        .accordian-inner-content {
            border-top: 2px solid #e5e5e5;
            padding: 45px 15px;
        }

        &.opened {
            z-index: 10;
        }

        &.closed {
            max-height: 0px;
            padding: 0;
        }
    }
}
</style>
